export function DrawDashedLine(ctx, sx, sy, ex, ey, thickness, fillColor, dashLen, spaceLen) {
  ctx.save();
  ctx.strokeStyle = fillColor;
  ctx.lineWidth = thickness;
  ctx.lineJoin = "miter";
  ctx.setLineDash([dashLen, spaceLen]);
  ctx.beginPath();
  ctx.moveTo(sx, sy);
  ctx.lineTo(ex, ey);
  ctx.stroke();
  ctx.restore();
}
